enum CurrencyType {
    None = 0,
    GBP = 1,
    EUR = 2,
    USD = 3
}

export { CurrencyType }